/* ========================== */
/*        COLLECTION          */
/* ========================== */

collectionNavSlider = {
    init: function () {
        if ($(".swiper--collection-nav").length > 0) {
            var swiper = new Swiper(".swiper--collection-nav", {
                slidesPerView: "auto",
                /*
                mousewheel: {
                    invert: false,
                    forceToAxis: true
                },
                */
                navigation: {
                    nextEl: ".swiper--collection-nav .swiper-btn.btn--next",
                    prevEl: ".swiper--collection-nav .swiper-btn.btn--prev",
                },
            });
        }
    }
};

filterSlider = {
    init: function () {
        if ($(".swiper--collection-filters").length > 0) {
            var swiper = new Swiper(".swiper--collection-filters", {
                slidesPerView: "auto",
                navigation: {
                    nextEl: ".collection__top__item.item--filters .swiper-btn.btn--next",
                    prevEl: ".collection__top__item.item--filters .swiper-btn.btn--prev",
                },
                /*
                mousewheel: {
                    invert: false,
                    forceToAxis: true
                },
                */
            });
        }
    }
};

sortBy = {
    init: function () {
        // Save existing sort parameters
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }

        // Add existing sort parameters to current URL
        document.querySelector('.sort-by').addEventListener('change', function (e) {
            var value = e.currentTarget.value;
            Shopify.queryParams.sort_by = value;
            location.search = new URLSearchParams(Shopify.queryParams).toString();
        });
    }
};

$(document).ready(function () {
    collectionNavSlider.init();
    filterSlider.init();
    sortBy.init();
});